export default __webpack_public_path__ + "static/media/thainight2.dbc135c3.jpg";